var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.box},[_c('img',{class:_vm.$style['head-image'],attrs:{"src":_vm.headImage,"alt":"头像"}}),_c('div',{class:_vm.$style['head-circle-image'],style:({ backgroundImage: `url(${_vm.headCircleImage})` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }